export default __webpack_public_path__ + "static/media/unmatch-vehicle.df89507a.svg";